// extracted by mini-css-extract-plugin
export default {"disclaimer":"F_bM"};